import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";

export const metadata: FigureMetadata = {
  id: "AID_FLOWS_SSA",
  title: defineMessage({
    id: "fig.finance.AID_FLOWS_SSA.title",
    defaultMessage: `Aid flows between major donors, recipients, and education sectors`,
  }),
  caption: defineMessage({
    id: "fig.finance.AID_FLOWS_SSA.caption",
    defaultMessage: `Donors vary a lot in how they direct their aid to different areas and regions.`,
  }),
  source: defineMessage({
    id: "fig.finance.AID_FLOWS_SSA.source",
    defaultMessage: `GEM Report team analysis based on OECD CRS`,
  }),
};
